import { Tab } from '@chakra-ui/react';

export const StyledTab = ({ children, ...props }: TODO) => {
  return (
    <Tab
      _selected={{
        backgroundColor: 'gray.50',
        borderTopColor: 'gray.200',
        borderRightColor: 'gray.200',
        borderLeftColor: 'gray.200',
      }}
      {...props}
    >
      {children}
    </Tab>
  );
};
